import { pathFor, Route } from '../routes';
const base = process.env.PUBLIC_URL || '';

const NAV = [
  { route: 'jobs', label: 'Jobs' },
  { route: 'companies', label: 'Startups and scaleups' },
  { route: 'about', label: 'How it works' },
  { route: 'post', label: 'Post a job' },
  // Only ever built into a local dev bundle, so it can't reach the live site.
  ...(process.env.NODE_ENV === 'development' ? [{ route: 'admin', label: 'Add a job' }] : []),
];

export function Header({ route }: { route: string }) {
  return (
    <header className="topbar">
      <a
        className="brand"
        href={pathFor('jobs')}
        aria-label="International Student Job Board - home"
        // Home means the whole board: every filter off, first page, no role open.
        data-reset-filters=""
      >
        <img className="brand-logo" src={`${base}/icons/logo.svg`} alt="" width={40} height={40} />
        <span className="brand-title">International Student Job Board</span>
      </a>

      <nav className="topnav" aria-label="Primary">
        {NAV.map((item) => (
          <a
            key={item.route}
            href={pathFor(item.route as Route)}
            className={`topnav-link${route === item.route ? ' is-active' : ''}`}
            aria-current={route === item.route ? 'page' : undefined}
          >
            {item.label}
          </a>
        ))}
      </nav>
    </header>
  );
}
